/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class MaxLengthValidator extends BaseValidator {
	constructor(size) {
		super();

		this.size = size;
	}

	name(model) {
		return "Field length must be less than " + this.size;
	}

	logic(x) {

		// negative values are nonsensical
		// but we use them to indicate no limit
		// since we can't override a model value
		// with null in the model trait
		if (this.size < 0) {
			return true
		}
		

		// attempt to validate UTF-8 strings based on this answer:
		// https://stackoverflow.com/a/42684638/385979
		return ((x != null) ? new Blob([x]).size <= this.size : true);
	}

	message() {
		return "Cannot be longer than " + this.size + " characters";
	}
}
